/* --- GENERIC VARS --- */
var speed = 300;
	ease  = 'easeInOutQuart';

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW ONLOAD) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).load(function()
{

/*
--------------
INIT FUNCTIONS
--------------
*/
sameHeight();                       // Same height
stickyHeader();                     // Sticky header
stickyFooter();                     // Sticky footer
alertWindow(speed, ease);           // Alert window
modalWindow(speed, ease);           // Modal window

// Main navigation
mainNavigation();

// Scroll to top
triggerScrollToTop();

// Services (mobile)
servicesMobile();

// Testimonials
testimonialsToggle();
testimonialsCheckHeight();

// Load more articles
// loadMoreArticles();

// Form validation
formValidation();

// Fix hero
fixHero();

/*
------------
INIT PLUGINS
------------
*/

// AOS
AOS.init(
{
	disable  : 'mobile',
	duration : speed * 2,
	easing   : ease
});

// Cycle
jQuery('.cycle').each(function(index, element)
{
	var classSlide = jQuery(element).attr('data-cycle-slides').substr(4);

	if(jQuery(classSlide, element).length > 1)
	{
		var id = jQuery(element).attr('id');

		jQuery(element).cycle(
		{
			easing : ease,
			pager  : '#' + id + '_pager',
			log    : false
		});
	}
});

// TEST: Alert window
// openCloseAlertwindow('#enquiry-form_success-message');

}); // End window load

/* ######################################################################################################################## */
/* SCRIPTS (DOCUMENT READY) ############################################################################################### */
/* ######################################################################################################################## */
jQuery(document).ready(function()
{

// Prevent default anchor action
jQuery('a').on('click', function(e)
{
	if(jQuery(this).attr('href') == '#')
		e.preventDefault();
});

}); // End document ready

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW RESIZE) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).bind('resizeEnd', function()
{
	sameHeight();       // Same height
	stickyFooter();     // Sticky footer

	// Testimonials
	testimonialsCheckHeight();

	// Fix hero
	fixHero();
});

// resizeEnd
jQuery(window).resize(function()
{
	if(this.resizeTO)
		clearTimeout(this.resizeTO);

	this.resizeTO = setTimeout(function()
	{
		jQuery(this).trigger('resizeEnd');
	}, 500);
});

/* ######################################################################################################################## */
/* MAIN NAVIGATION ######################################################################################################## */
/* ######################################################################################################################## */
function mainNavigation()
{
	// Init active item
	jQuery('li', '#main-navigation').eq(0).addClass('active');

	// Trigger main navigation
	jQuery('#main-navigation-trigger').on('click', function()
	{
		jQuery('body').toggleClass('main_navigation_active');
	});

	// Scroll to section
	jQuery('a', '#main-navigation').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		idSection = jQuery(this).attr('href');

		jQuery(this).parent().addClass('active')
		jQuery(this).parent().siblings().removeClass('active');

		jQuery('html, body').animate(
		{
			scrollTop : jQuery(idSection).offset().top - 136
		}, speed*3, ease, function()
		{
			jQuery('body').removeClass('main_navigation_active');
		});
	});
}

/* ######################################################################################################################## */
/* SCROLL TOP ############################################################################################################# */
/* ######################################################################################################################## */
jQuery(window).scroll(function(e)
{
	scrollToTop();
});

function scrollToTop()
{
	var scroll  = jQuery(window).scrollTop();
		hWindow = jQuery(window).height();

	if(scroll > hWindow)
		jQuery('#scroll-top').addClass('show');
	else
		jQuery('#scroll-top').removeClass('show');
}

function triggerScrollToTop()
{
	jQuery('#scroll-top').on('click', function()
	{
		jQuery('html, body').animate(
		{
			scrollTop : 0
		}, speed*3, ease);
	});
}

/* ######################################################################################################################## */
/* SERVICES (MOBILE) ###################################################################################################### */
/* ######################################################################################################################## */
function servicesMobile()
{
	if(jQuery(window).width() <= 910)
	{
		jQuery('.item .content .heading.type_3', '.services').on('click', function()
		{
			var jQthis   = jQuery(this);
				hHeading = jQthis.outerHeight(true);
				hList    = jQthis.next().outerHeight(true);
				parent   = jQthis.parents('.content');

			parent.parent().parent().siblings().find('.content')
				.height('2px')
				.removeClass('open');

			if(parent.hasClass('open'))
			{
				parent
					.height('2px')
					.removeClass('open');
			}
			else {
				parent
					.height(hHeading + hList)
					.addClass('open');
			}
		});
	}
}

/* ######################################################################################################################## */
/* TESTIMONIALS ########################################################################################################### */
/* ######################################################################################################################## */
function testimonialsToggle()
{
	jQuery('.link_testimonial', '.clients').on('click', function()
	{
		var jQthis = jQuery(this);

		jQthis.parent().parent().siblings().find('.testimonial').addClass('closing');
		setTimeout(function(){ jQthis.parent().parent().siblings().find('.testimonial').removeClass('active closing') }, speed);

		jQthis.next('.testimonial').toggleClass('active');
	});

	jQuery('.close', '.testimonial').on('click', function()
	{
		var jQthis = jQuery(this);

		jQthis.parents('.testimonial').addClass('closing');
		setTimeout(function(){ jQthis.parents('.testimonial').removeClass('active closing') }, speed);
	});
}
function testimonialsCheckHeight()
{
	jQuery('.testimonial', '.clients').each(function()
	{
		jQuery('.content', this).removeClass('scroll');

		var h_testimonial = jQuery(this).height();
			h_content     = jQuery('.content', this).height();

		if(h_content > h_testimonial)
			jQuery('.content', this).addClass('scroll');
	});
}

/* ######################################################################################################################## */
/* PARALLAX ############################################################################################################### */
/* ######################################################################################################################## */
jQuery(window).scroll(function(e)
{
	parallax();
});

function parallax()
{
	var hWindow = jQuery(window).height();

	jQuery('.parallax').each(function()
	{
		var jQthis = jQuery(this);

		if(elementScrolled(jQthis))
		{
			var fracs      = jQthis.fracs();
				percentage = (fracs.rects.viewport.top - 0) / (hWindow - 0) * 100;

			jQthis.css('background-position', '50% calc(100% - ' + percentage + '%)');
		}
	});

	function elementScrolled(elem)
	{
		var docViewTop    = jQuery(window).scrollTop();
			docViewBottom = docViewTop + jQuery(window).height();
			elemTop       = jQuery(elem).offset().top;
			hElem         = jQuery(elem).outerHeight();

		return ((elemTop <= docViewBottom) && ((elemTop + hElem) >= docViewTop));
	}
}

/* ######################################################################################################################## */
/* LOAD MORE ARTICLES ##################################################################################################### */
/* ######################################################################################################################## */
/*
function loadMoreArticles()
{
	jQuery('.container_post').slice(0, 12).fadeIn(speed, ease, function()
	{
		if(jQuery('.container_post:hidden').length == 0)
			jQuery('#archive-load-more').parent().slideUp(speed, ease);
	});

	jQuery('#archive-load-more').on('click', function(e)
	{
		e.preventDefault();

		jQuery('#archive-load-more').parent().addClass('on-loading');

		setTimeout(function()
		{
			jQuery('.container_post:hidden').slice(0, 4)
				.fadeIn(speed, ease)
				.addClass('loaded');

			jQuery('#archive-load-more').parent().removeClass('on-loading');

			if(jQuery('.container_post:hidden').length == 0)
				jQuery('#archive-load-more').parent().slideUp(speed, ease);

			jQuery('html, body').animate(
			{
				scrollTop : jQuery('.container_post.loaded').last().offset().top - jQuery('#header').height()
			}, speed * 2, ease);
		}, 800);
	});
}
*/

/* ######################################################################################################################## */
/* FORM VALIDATION ######################################################################################################## */
/* ######################################################################################################################## */
jQuery.fn.validate = function()
{
	return jQuery(this).each(function()
	{
		var jQfield         = jQuery(this).closest('.js-field'),
			jQfieldFeedback = jQfield.find('.field_feedback');

		jQfield.removeClass('is-valid is-invalid');

		if(jQuery(this).is(':valid'))
		{
			jQfield.addClass('is-valid');
		}
		else if(jQuery(this).is(':invalid'))
		{
			var validity      = jQuery(this).prop('validity');
			var validationMsg = jQfieldFeedback.data('validation-msg')

			if(!jQfieldFeedback.data('validation-msg'))
			{
				var message = 'There is a problem with the data inputted';

				if(validity.valueMissing === true)
					message = 'This is a required field';

				else if(validity.typeMismatch === true && jQuery(this).attr('type') === 'email')
					message = 'Please enter a valid email address';

				else if (validity.typeMismatch === true && jQuery(this).attr('type') === 'url')
					message = 'Please enter a valid website address';

				else if (validity.tooShort === true)
					message = 'Must be a minimum of ' + jQuery(this).attr('minlength') + ' characters';

				else if (validity.tooLong === true)
					message = 'Must be a maximum of ' + jQuery(this).attr('maxLength') + ' characters';

				jQfieldFeedback.html(message);
			}
			else
			{
				jQfieldFeedback.html(validationMsg);
			}

			jQfield.addClass('is-invalid');
		}
	});
};

function formValidation()
{
	jQuery('input, select, textarea').change(function()
	{
		jQuery(this).validate();

		setTimeout(function()
		{
			checkModalHeight('#enquiry-form');
		}, speed);
	});

	jQuery('form').submit(function(e)
	{
		e.preventDefault();

		jQuery(this).find('input, select, textarea').validate();

		setTimeout(function()
		{
			checkModalHeight('#enquiry-form');
		}, speed);

		if(jQuery(this).find('.js-field.is-invalid').length)
		{
			jQuery(this).find('.js-alert.is-invalid').slideDown(speed, ease);
			jQuery('.is-invalid', jQuery(this)).first().find('input, select, textarea').focus();
		}
		else
		{
			jQuery(this).find('.js-alert.is-invalid').slideUp();

			var $recaptcha = jQuery(this).find('.g-recaptcha');

			if ($recaptcha.length) {
				e.preventDefault();
				var recaptchaId = $recaptcha.data('recaptcha-id');

				currentRecaptchaId = recaptchaId;
				grecaptcha.execute(recaptchaId);
			}
		}
	});
}

/* ######################################################################################################################## */
/* FIX HERO ############################################################################################################### */
/* ######################################################################################################################## */
function fixHero()
{
	if(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)
	{
		jQuery('#hero-column-center-middle').attr('style', '');

		var hCenter = jQuery('#hero-column-center').height();
			hTop    = jQuery('#hero-column-center-top').height();
			hBottom = jQuery('#hero-column-center-bottom').height();

		jQuery('#hero-column-center-middle').height(hCenter - hTop - hBottom);
	}
}
